import { IGlobalReducerState } from '../Base/interface/IGlobalReducerState';

const getIsCollapsed = (state: IGlobalReducerState) => state.obra.isCollapsed;
const getObra = (state: IGlobalReducerState) => state.obra.Obra;
const getConstructionSiteIds = (state: IGlobalReducerState) => state.obra.constructionSiteIds;
const getObrasList = (state: IGlobalReducerState) => state.obra.ObrasList;

export { getIsCollapsed, getObra, getConstructionSiteIds, getObrasList };
